import httpClient from "./httpClient";

const getUserInfo = () => httpClient.get('/account/detail-user/',{
        user_id: localStorage.getItem('user_id')
})
const getUserBYId = (id) => httpClient.get('/account/detail-user/?user_id='+`${id}`)

const getUsers = (params) => httpClient.get(`/account/list-users/`, {
    params: params
})

const updateUser = (params) => httpClient.put(`/account/update-user/`, params)

const deleteUser = (id) => httpClient.delete(`/account/delete-user/?user_id=${id}`)

const addUser = (params) => httpClient.post(`/account/register/`, params)

export {
    getUserInfo,
    getUsers,
    getUserBYId,
    addUser,
    updateUser,
    deleteUser
}
